export const USER_TOKEN_KEY = 'token';
export const LEGACY_ACCESS_TOKEN_KEY = 'access_token';
export const REFRESH_TOKEN_KEY = 'refresh_token';
export const ADMIN_TOKEN_KEY = 'adminToken';

const hasLocalStorage = () => typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';

const isAdminRoute = () => (
  typeof window !== 'undefined' &&
  window.location?.pathname?.toLowerCase().includes('/admin')
);

export const getStoredAuthToken = ({ preferAdmin = isAdminRoute() } = {}) => {
  if (!hasLocalStorage()) return null;

  const userToken = localStorage.getItem(USER_TOKEN_KEY) || localStorage.getItem(LEGACY_ACCESS_TOKEN_KEY);
  const adminToken = localStorage.getItem(ADMIN_TOKEN_KEY);

  return preferAdmin ? adminToken : userToken;
};

export const setStoredAuthToken = (token, { admin = false } = {}) => {
  if (!hasLocalStorage()) return;

  if (!token) {
    clearStoredAuthTokens();
    return;
  }

  if (admin || token.startsWith('admin_')) {
    localStorage.setItem(ADMIN_TOKEN_KEY, token);
    return;
  }

  localStorage.setItem(USER_TOKEN_KEY, token);
  localStorage.setItem(LEGACY_ACCESS_TOKEN_KEY, token);
};

export const setStoredRefreshToken = (token) => {
  if (!hasLocalStorage()) return;

  if (token) {
    localStorage.setItem(REFRESH_TOKEN_KEY, token);
  } else {
    localStorage.removeItem(REFRESH_TOKEN_KEY);
  }
};

export const clearStoredAuthTokens = () => {
  if (!hasLocalStorage()) return;

  clearStoredUserAuthTokens();
  clearStoredAdminToken();
};

export const clearStoredUserAuthTokens = () => {
  if (!hasLocalStorage()) return;

  localStorage.removeItem(USER_TOKEN_KEY);
  localStorage.removeItem(LEGACY_ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
};

export const clearStoredAdminToken = () => {
  if (!hasLocalStorage()) return;

  localStorage.removeItem(ADMIN_TOKEN_KEY);
};

// Marketing dashboard token: separate from customer/admin tokens and only ever
// sent to /api/marketing/ endpoints.
export const MARKETING_TOKEN_KEY = 'marketingToken';

export const getStoredMarketingToken = () => {
  if (!hasLocalStorage()) return null;

  try {
    return localStorage.getItem(MARKETING_TOKEN_KEY);
  } catch (error) {
    return null;
  }
};

export const setStoredMarketingToken = (token) => {
  if (!hasLocalStorage()) return;

  try {
    if (token) {
      localStorage.setItem(MARKETING_TOKEN_KEY, token);
    } else {
      localStorage.removeItem(MARKETING_TOKEN_KEY);
    }
  } catch (error) {
    // Storage can be unavailable (private mode / quota); the session just won't persist.
  }
};

export const clearStoredMarketingToken = () => {
  if (!hasLocalStorage()) return;

  try {
    localStorage.removeItem(MARKETING_TOKEN_KEY);
  } catch (error) {
    // Ignore storage failures.
  }
};
